import React, { useEffect } from 'react';
import { PageHero } from '../components/page/PageHero';
import { IncludedList } from '../components/page/IncludedList';
import { WhyLawyerLed } from '../components/page/WhyLawyerLed';
import { Process } from '../components/home/Process';
import { FeeTransparency } from '../components/page/FeeTransparency';
import { MiniFAQ } from '../components/page/MiniFAQ';
import { FinalCTA } from '../components/home/FinalCTA';
const INCLUDED = [{
  title: 'Contract and Section 32 review',
  body: 'We read the contract of sale and vendor statement and explain what they mean for you before you commit.'
}, {
  title: 'Special-condition advice',
  body: 'Finance, building and pest, subject-to-sale and other conditions reviewed so you understand your obligations.'
}, {
  title: 'Title and disclosure checks',
  body: 'Easements, covenants, owners corporation and disclosure matters considered as part of the review.'
}, {
  title: 'Auction and private sale',
  body: 'Advice tailored to how you are buying, including the unconditional nature of most auction contracts.'
}, {
  title: 'Settlement coordination',
  body: 'The team manages documents, dates, adjustments and settlement so the purchase completes properly.'
}, {
  title: 'Questions answered directly',
  body: 'Speak with the team handling your file when something needs clarifying, not a call centre.'
}];
const FAQS = [{
  q: 'When should I have the contract reviewed?',
  a: 'Before signing or bidding wherever possible. A review can identify conditions, disclosures and risks that may affect your decision or require further advice.'
}, {
  q: 'Can you review a contract before auction?',
  a: 'Yes. The contract should ideally be reviewed before auction day because auction contracts are generally unconditional once the property is purchased. Send the contract and auction date with your enquiry.'
}, {
  q: 'What does it cost?',
  a: 'You receive a clear scope and fee before any work begins, so you can decide with the cost in front of you. Send the details for a quote.'
}];
export function BuyingProperty() {
  useEffect(() => {
    document.title = 'Buying Property in Victoria | L.A Property Law';
    window.scrollTo(0, 0);
  }, []);
  return <main data-id="element-610">
      <PageHero eyebrow="buying property" title="Know what you are signing before you buy." intro="Get the contract reviewed, understand the conditions and find out what needs attention before you commit to a Victorian property purchase." imageSrc="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1200&q=80" imageAlt="Warm contemporary Melbourne home interior with natural light" data-id="element-611" />
      <IncludedList eyebrow="what is included" heading="Buyer support from contract to settlement." intro="A lawyer-led review of the contract and vendor statement, followed by coordinated management through to settlement." items={INCLUDED} data-id="element-612" />
      <WhyLawyerLed data-id="element-613" />
      <Process data-id="element-614" />
      <FeeTransparency variant="background" data-id="element-615" />
      <MiniFAQ items={FAQS} data-id="element-616" />
      <FinalCTA data-id="element-617" />
    </main>;
}